import { render, staticRenderFns } from "./LabProcedure.vue?vue&type=template&id=11efb338"
import script from "./LabProcedure.vue?vue&type=script&lang=js"
export * from "./LabProcedure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports